import type { Client } from 'typesense';

import type { ResolvedExperimentData } from '@change-corgi/experiments/configs';

import { useSearchPageData } from '#src/app/pages/search/pageContext';
import { useSearchIndexName, useSearchClient } from '#src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	typesenseClient: Client;
	collectionName: string;
	preset: string;
	searchVectorCollectionExperiment: ResolvedExperimentData;
}>;

export function useLayout(): Result {
	const {
		data: { typesenseClient },
	} = useSearchClient();

	const {
		data: { searchIndexName, searchPreset },
	} = useSearchIndexName();

	const {
		data: {
			experiments: { searchVectorCollection },
		},
	} = useSearchPageData();

	return {
		data: {
			typesenseClient,
			collectionName: searchIndexName,
			preset: searchPreset,
			searchVectorCollectionExperiment: searchVectorCollection,
		},
	};
}
